import LocalizedStrings from 'localized-strings';

export default new LocalizedStrings({
  en: {
    aboutTheRules: {
      mandatee:
        'To validate the account as quickly as possible, make sure that the document meets the following criteria:',
      nonMandatee:
        'To validate your account as quickly as possible, make sure that your document meets the following criteria:',
    },

    checks: {
      pdf: 'Ideally in PDF format.',
      readable: 'The document must be **fully legible, neat and uncut**.',
    },
    title: {
      mandatee: 'Upload the company’s draft statutes',
      nonMandate: 'Upload your company’s draft statutes',
    },
    upload: {
      description: 'or **select** a file',
      title: {
        mandatee: 'Drag the document here',
        nonMandate: 'Drag your document here',
      },
    },
  },
  fr: {
    aboutTheRules: {
      mandatee:
        'Pour valider le compte au plus vite, assurez-vous que le document remplit les critères suivants\u00A0:',
      nonMandatee:
        'Pour valider votre compte au plus vite, assurez-vous que votre document remplit les critères suivants\u00A0:',
    },
    checks: {
      pdf: 'Idéalement en **format PDF**.',
      readable:
        'Le document doit être **parfaitement lisible, net et entier**.',
    },
    title: {
      mandatee: 'Ajoutez le projet de statuts',
      nonMandate: 'Ajoutez votre projet de statuts',
    },
    upload: {
      description: 'ou **sélectionnez** un fichier',
      title: {
        mandatee: 'Déposez le document ici',
        nonMandate: 'Déposez votre document ici',
      },
    },
  },
} as const);
